module.exports = __webpack_public_path__ + "img/delete.f31b0b38.svg";